import { render, staticRenderFns } from "./g-qrcode.vue?vue&type=template&id=424c251e&scoped=true"
import script from "./g-qrcode.vue?vue&type=script&lang=ts"
export * from "./g-qrcode.vue?vue&type=script&lang=ts"
import style0 from "./g-qrcode.vue?vue&type=style&index=0&id=424c251e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424c251e",
  null
  
)

export default component.exports